import { render, staticRenderFns } from "./VSelectRange.vue?vue&type=template&id=40d84dd8&"
import script from "./VSelectRange.vue?vue&type=script&lang=js&"
export * from "./VSelectRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports